export default __webpack_public_path__ + "static/contact-banner-819115f19d6113779dd09de41dd7caea.jpg";